// Services
import request from "../request/request";
import sessionStorage from "../storage/SessionStorage";

class auth {
	isAuth() {
		const tokens = this.getTokens();
		if (tokens) {
			return true;
		} else {
			return false;
		}
	}

	async authenticate(code) {
		const config = {
			url: "/auth/authorize",
			data: { code },
		};
		const res = await request.post(config);
		return res;
	}

	computeExpirationDate(authObj) {
		let expDate = new Date();
		expDate.setSeconds(expDate.getSeconds() + parseInt(authObj?.expires_in));
		return expDate.toString();
	}

	setTokens(authObj) {
		if (authObj) {
			const newAuthObj = {
				...authObj,
			};
			sessionStorage.setPathName("authObj", JSON.stringify(newAuthObj));
			return newAuthObj;
		} else {
			return false;
		}
	}

	getTokens() {
		const authObj = JSON.parse(sessionStorage.getPathName("authObj"));
		return authObj ? authObj : null;
	}

	getExpirationDate() {
		return JSON.parse(sessionStorage.getPathName("authObj"))?.expiration_date;
	}

	isActive() {
		const date1 = new Date("01/01/2025");
		const date2 = new Date();
		const diffTime = Math.abs(date2 - date1);
		const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
		return diffDays <= 730;
	}

	logout() {
		sessionStorage.clear();
		window.location.href = "/login";
	}
}

export default new auth();
